import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { audioManager } from 'lib/audio/audio-manager';
import { AUDIO_TYPES } from 'lib/audio/audio.types';

import { MoveIcon } from 'shared/components/ui/MoveIcon/move-icon';
import { Status } from 'shared/components/ui/MoveIcon/move-icon.types';
import { MovesEnum } from 'shared/constants/shared-enums';

import { MOVES } from './rock-paper-scissors.constants';

interface IRockPaperScissorsProps {
  move?: MovesEnum;
  selectMove: (move: MovesEnum) => void;
}

export const RockPaperScissors = React.forwardRef<HTMLDivElement, IRockPaperScissorsProps>(
  ({ move, selectMove }, ref) => {
    const { t } = useTranslation();

    const handleMoveClick = useCallback(
      (selectedMove: MovesEnum) => {
        selectMove(selectedMove);
        audioManager.playSound(AUDIO_TYPES.CLICK);
      },
      [selectMove],
    );

    return (
      <div ref={ref} className="flex w-full items-center justify-evenly px-0 sm:px-1">
        {MOVES.map(({ type, img, imgNotActive, translationKey }, index) => (
          <React.Fragment key={type}>
            <MoveIcon
              clickHandler={() => handleMoveClick(type)}
              imgSrc={img}
              imgSrcNotActive={imgNotActive}
              text={t(translationKey)}
              status={!move ? Status.Active : move === type ? Status.Selected : Status.Disabled}
              disabled={!!move && move !== type}
            />
            {index < MOVES.length - 1 && (
              <div className="h-[5.3125rem] w-[0.0625rem] bg-white/25 sm:h-[8rem] xlg:block" />
            )}
          </React.Fragment>
        ))}
      </div>
    );
  },
);
